import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import Image from 'next/image'
import React from 'react'
import DefaultLoadingSpinner from '../../loading-spinners/default-loading-spinner'

type Props = {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm?: () => void
  onCancel?: () => void
  title?: string
  description?: string
  affirmative_button_text?: string
  negative_button_text?: string
  isExecuting?: boolean
}

const RemoveItemAlert = ({
  open,
  onOpenChange,
  onConfirm,
  onCancel,
  title,
  description,
  affirmative_button_text,
  negative_button_text,
  isExecuting,
}: Props) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-full max-w-[90%] px-5 sm:max-w-[516px] sm:px-13">
        <div className="flex justify-end">
          <DialogClose disabled={isExecuting}>
            <Image
              priority
              src={'/icons/close.svg'}
              height={24}
              width={24}
              alt={'people'}
              className={`size-6`}
            />
          </DialogClose>
        </div>
        <DialogHeader>
          <DialogTitle className="m-auto max-w-[calc(417/16*1rem)] text-center font-serif text-xl uppercase sm:text-4xl">
            {title}
          </DialogTitle>
          <DialogDescription className="text-sm text-black">
            {description}
          </DialogDescription>
        </DialogHeader>

        <div className="flex flex-col gap-4">
          <Button
            disabled={isExecuting}
            onClick={onCancel}
            className="w-full uppercase"
          >
            {negative_button_text}
          </Button>
          <Button
            disabled={isExecuting}
            onClick={onConfirm}
            className="w-full uppercase"
            variant="outline"
          >
            {isExecuting ? (
              <DefaultLoadingSpinner iconClassName="text-primary-400" />
            ) : (
              affirmative_button_text
            )}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default RemoveItemAlert
